export const ProductsRoute = "/products";
export const ProductsWithMaterialRoute = "/products/:material";
export const TacticalPartsRoute = "/tacticalparts";
export const PartsPerPsmRoute = "/partsperpsm";
export const MissedSalesRoute = "/missedsales";
export const DashboardExportRoute = "/dashboardexport";
export const NewPartRoute = "/newpart";
